import { __assign, __extends } from "tslib";
import React, { Component } from 'react';
var popover = function (isOpen) {
    if (isOpen === void 0) { isOpen = true; }
    return function (BaseComponent) {
        return /** @class */ (function (_super) {
            __extends(Popover, _super);
            function Popover() {
                var _this = _super !== null && _super.apply(this, arguments) || this;
                _this.state = { isOpen: isOpen };
                _this.toggle = function () {
                    _this.setState(function (state) { return ({ isOpen: !state.isOpen }); });
                };
                return _this;
            }
            Popover.prototype.render = function () {
                return (React.createElement(BaseComponent, __assign({ isPopoverOpen: this.state.isOpen, togglePopover: this.toggle }, this.props)));
            };
            return Popover;
        }(Component));
    };
};
export default popover;
